import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Typography from "@mui/material/Typography";
import { formatValue } from "../utils/data.js";
import Tooltip from "../Tooltip/Tooltip.js";
const CellValue = (t0) => {
  const $ = c(11);
  const {
    value,
    columnType,
    type: t1,
    format: t2
  } = t0;
  const type = t1 === void 0 ? "float" : t1;
  let fullFormatValue;
  let t3;
  if ($[0] !== columnType || $[1] !== t2 || $[2] !== type || $[3] !== value) {
    const format = t2 === void 0 ? {} : t2;
    const formatOptions = {
      type: columnType,
      short: !(columnType === "percentage"),
      precision: type !== "integer" ? 2 : 0,
      ...format
    };
    fullFormatValue = formatValue(value, {
      ...formatOptions,
      short: false
    });
    t3 = formatValue(value, formatOptions);
    $[0] = columnType;
    $[1] = t2;
    $[2] = type;
    $[3] = value;
    $[4] = fullFormatValue;
    $[5] = t3;
  } else {
    fullFormatValue = $[4];
    t3 = $[5];
  }
  const readableValue = t3;
  let t4;
  if ($[6] !== readableValue) {
    t4 = /* @__PURE__ */ jsx(Typography, { variant: "valueCell", className: "number-sm", children: readableValue });
    $[6] = readableValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fullFormatValue || $[9] !== t4) {
    t5 = /* @__PURE__ */ jsx(Tooltip, { placement: "top", title: fullFormatValue, children: t4 });
    $[8] = fullFormatValue;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export {
  CellValue as default
};
